import type { TaskPayReportItemType, TaskPayReportRowType } from '@econtractor/types';

const taskAmount = (row: TaskPayReportItemType): number =>
    row.pay ? Number(row.payAmount) || 0 : 0;

export const filterTasksByStatus = (
    users: TaskPayReportRowType[],
    statuses: number[],
    showZeroTasks: boolean,
): TaskPayReportRowType[] => {
    if (!statuses.length) return [];

    const allowed = new Set(statuses.map((status) => Number(status)));
    const result: TaskPayReportRowType[] = [];

    for (const user of users) {
        const rows = (user.rows || []).filter((row) => {
            if (!allowed.has(Number(row.taskStatus))) return false;
            if (!showZeroTasks && taskAmount(row) === 0) return false;
            return true;
        });
        if (!rows.length) continue;
        result.push({ ...user, rows });
    }

    return result;
};
